import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "dashboard-wrapper tw-pb-16 tw-box-border" }
const _hoisted_2 = {
  key: 0,
  class: "tw-flex tw-flex-col tw-justify-center tw-items-center tw-h-full tw-w-full"
}
const _hoisted_3 = {
  key: 1,
  class: "tw-flex tw-flex-col tw-items-center tw-justify-center"
}
const _hoisted_4 = { class: "tw-flex tw-flex-col tw-gap-6 tw-w-full tw-h-full" }
const _hoisted_5 = { class: "tw-w-full tw-h-full tw-grid tw-grid-cols-1 tw-gap-6 tw-box-border rlg:tw-grid-cols-2" }
const _hoisted_6 = { class: "tw-w-full tw-h-full tw-flex tw-flex-col tw-gap-6" }
const _hoisted_7 = { class: "tw-w-full tw-h-full tw-flex tw-flex-col tw-gap-6" }

import { computed, onBeforeMount, ref } from "vue";
import { useStore } from "vuex";
import { USER_STORE } from "@/store/modules/user";
import { WORKSTATION } from "@/store/modules/workstation";
import { setDirectStoragePathToImage } from "@/core/utils/common";
import { MEMBER_STORE } from "@/store/modules/manage-member";
import ProjectsOverviewWidget from "@/modules/dashboard/components/Widgets/ProjectsOverviewWidget.vue";
import TeamWidget from "@/modules/dashboard/components/Widgets/TeamWidget.vue";
import NwgCalendarEventWidget from "@/modules/dashboard/components/Widgets/NwgCalendarEventWidget.vue";
import CreateNewJobWidget from "./Widgets/CreateNewJobWidget.vue";
import Loader from "@/core/components/common/Loader.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'NWGDashboard',
  setup(__props) {

const store = useStore();
const teamMemberLoading = ref(false);
const members = ref([]) as any;

const isWorkstationLoading = computed(
  () => store.getters[`${WORKSTATION}/loadingWorkstation`]
);

const user = computed(() => store.getters[`${USER_STORE}/user`]);

const getTeamMember = async () => {
  try {
    teamMemberLoading.value = true;
    const response = await store.dispatch(`${MEMBER_STORE}/getTeamMember`, {
      userId: user.value?.id,
    });

    members.value = await Promise.all(
      response.map(async (member: any) => {
        if (member?.toUser?.userPublicProfile) {
          member.userProfileImageUrl = setDirectStoragePathToImage(
            member?.toUser?.userPublicProfile?.profileImage
          );
        } else {
          member.userProfileImageUrl = null;
        }
        return member;
      })
    );
  } catch (err) {
    console.log();
  } finally {
    teamMemberLoading.value = false;
  }
};

onBeforeMount(async () => {
  getTeamMember();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("main", _hoisted_1, [
      (isWorkstationLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(Loader, { show: isWorkstationLoading.value }, null, 8, ["show"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("section", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(TeamWidget, {
                    className: "!tw-min-h-[275px]",
                    propMembers: members.value,
                    onGetMembers: getTeamMember
                  }, null, 8, ["propMembers"])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(NwgCalendarEventWidget, { className: "property_calendar" })
                ])
              ])
            ])
          ]))
    ])
  ]))
}
}

})